import React, { useEffect, useState } from "react";
import { MdDoneOutline, MdVisibility, MdWarning } from "react-icons/md";
import { FiCheckCircle, FiAlertTriangle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import ProspectPropertyService from "../../../../Service/ProspectPropertyService";
import { PropertyTypeList } from "../../../../../Enum";
import { userRole, userUid } from "../../../../../utils/storage";
import PresentationPropertyService from "../../../../Service/PresentationPropertyService";

const InSalesPage = ({
  propertyId,
  selectedPropertyData,
  propertyData,
  isConfirmed,
}) => {
  const [presentationProperty, setPresentationProperty] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  // Function to calculate property completion percentage
  const calculatePropertyCompletion = (propertyData) => {
    if (!propertyData) return { percentage: 0, filledCount: 0, totalCount: 0 };

    // Define essential fields that should be filled for a complete property
    const essentialFields = [
      "name",
      "propertyId",
      "propertyThumbnail",
      "overAllSqft",
      "dtcpNo",
      "guidelineValue",
      "documentType",
      "landmark",
      "roiPercentage",
      "roiYear",
      "reraId",
      "surveyFee",
      "surveyNo",
      "documentCharge",
      "propertyPurchasedDate",
      "underOfGovernance",
      "sro",
      "taluk",
      "geoLocation",
      "address",
      "locationLink",
      "totalProjectWorth",
      "propertySellerName",
      "propertySellerPhoneNumber",
      "propertyVendorName",
      "propertyVendorPhoneNumber",
      "constructionType",
      "ageOfTheProperty",
      "possessionDate",
      "fullyCoveredParkingCharge",
      "semiCoveredParkingCharge",
      "openParkingCharge",
      "driveLink",
      "approvalType",
    ];

    // Array fields that should have at least one item
    const arrayFields = [
      "salesTeam",
      "basicAmenities",
      "futureAmenities",
      "nearByAmenities",
      "propertyImages",
      "propertyBlueprints",
      "propertyDocuments",
      "propertyFlyers",
      "propertyVideos",
    ];

    let filledCount = 0;
    const totalCount = essentialFields.length + arrayFields.length;

    // Check essential fields
    essentialFields.forEach((field) => {
      const value = propertyData[field];
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== 0
      ) {
        filledCount++;
      }
    });

    // Check array fields
    arrayFields.forEach((field) => {
      const value = propertyData[field];
      if (Array.isArray(value) && value.length > 0) {
        filledCount++;
      }
    });

    const percentage = Math.round((filledCount / totalCount) * 100);

    return {
      percentage,
      filledCount,
      totalCount,
      remainingCount: totalCount - filledCount,
    };
  };

  const navigate = useNavigate();

  const fetchPresantationPropertyById = async (id) => {
    try {
      setIsLoading(true);
      const response =
        await PresentationPropertyService.getProspectPropertyIdBasedOnPropertyId(
          id
        );
      if (response.status === 200) {
        const data = response.data?.propertyData;
        setPresentationProperty(data);
      }
    } catch (error) {
      console.error("Error fetching property by ID:", error);
      setPresentationProperty([]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (selectedPropertyData?.id) {
      fetchPresantationPropertyById(selectedPropertyData.id);
    }
  }, [selectedPropertyData]);

  const handleSubmit = () => {
    if (!selectedPropertyData?.propertyType?.name) return;

    setIsLoading(true);
    const type = selectedPropertyData?.propertyType?.name;

    const selectedPropertyDetails = {
      id: selectedPropertyData?.propertyType?.id,
      label: selectedPropertyData?.propertyType?.name,
    };
    const selectedSaleName = selectedPropertyData?.propertySaleType?.name;
    const selectedSaleType = selectedPropertyData?.propertySaleType?.id;

    // Add a slight delay for better UX
    setTimeout(() => {
      setIsLoading(false);
      if (type === "Layout") {
        navigate(`/presentation-property/layout`, {
          state: {
            selectedPropertyDetails,
            propertySaleType: selectedSaleType,
            selectedSaleName: selectedSaleName,
            prospectPropertyId: selectedPropertyData?.id,
          },
        });
        return;
      }
      if (type === "Acres and Cents") {
        navigate(`/presentation-property/acres-and-cents`, {
          state: {
            selectedPropertyDetails,
            propertySaleType: selectedSaleType,
            selectedSaleName: selectedSaleName,
            prospectPropertyId: selectedPropertyData?.id,
          },
        });
        return;
      }
      if (type === "Resale Plot") {
        navigate(`/presentation-property/resale-plot`, {
          state: {
            selectedPropertyDetails,
            propertySaleType: selectedSaleType,
            selectedSaleName: selectedSaleName,
            prospectPropertyId: selectedPropertyData?.id,
          },
        });
        return;
      }

      if (type === "Villa") {
        navigate(`/villa-properties-manage`, {
          state: {
            selectedPropertyDetails,
            propertySaleType: selectedSaleType,
            selectedSaleName: selectedSaleName,
          },
        });
        return;
      }

      if (type === "Apartment") {
        navigate(`/apartment-properties-manage`, {
          state: {
            selectedPropertyDetails,
            propertySaleType: selectedSaleType,
            selectedSaleName: selectedSaleName,
          },
        });
        return;
      }
    }, 300);
  };

  const handleExitingSubmite = () => {
    if (presentationProperty && presentationProperty.id) {
      setIsLoading(true);
      const selectedPropertyDetails = {
        id: selectedPropertyData?.propertyType?.id,
        label: selectedPropertyData?.propertyType?.name,
      };
      const selectedSaleName = selectedPropertyData?.propertySaleType?.name;
      const selectedSaleType = selectedPropertyData?.propertySaleType?.id;
      const type = selectedPropertyData?.propertyType?.name;

      setTimeout(() => {
        setIsLoading(false);
        if (type === "Layout") {
          navigate(`/presentation-property/layout`, {
            state: {
              propertyId: presentationProperty?.id,
              propertyInfoStatus: true,
              propertySaleType: presentationProperty?.propertySaleType?.name,
              prospectPropertyId: selectedPropertyData?.id,
              propertyName: presentationProperty?.name,
              propertyTypeId: presentationProperty?.propertyType?.id,
            },
          });
          return;
        }
        if (type === "Acres and Cents") {
          navigate(`/presentation-property/acres-and-cents`, {
            state: {
              propertyId: presentationProperty?.id,
              propertyInfoStatus: true,
              propertySaleType: presentationProperty?.propertySaleType?.name,
              prospectPropertyId: selectedPropertyData?.id,
              propertyName: presentationProperty?.name,
              propertyTypeId: presentationProperty?.propertyType?.id,
            },
          });
          return;
        }
        if (type === "Resale Plot") {
          navigate(`/presentation-property/resale-plot`, {
            state: {
              propertyId: presentationProperty?.id,
              propertyInfoStatus: true,
              propertySaleType: presentationProperty?.propertySaleType?.name,
              prospectPropertyId: selectedPropertyData?.id,
              propertyName: presentationProperty?.name,
              propertyTypeId: presentationProperty?.propertyType?.id,
            },
          });
          return;
        }

        if (selectedPropertyData?.propertyType?.name === "Villa") {
          navigate(`/villa-properties-manage`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName: selectedSaleName,
            },
          });
          return;
        }
        if (selectedPropertyData?.propertyType?.name === "Apartment") {
          navigate(`/apartment-properties-manage`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName: selectedSaleName,
            },
          });
          return;
        }
      }, 300);
    }
  };
 return (
    <div className="bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-2xl shadow-soft-all border border-gray-100 p-8 h-[457px] flex items-center justify-center relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-customGreen/10 to-transparent rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-custom-bright-green/10 to-transparent rounded-full translate-y-12 -translate-x-12"></div>
      
      {isConfirmed ? (
        <div className="flex flex-col items-center justify-center text-center animate-fadeIn z-10 relative">
          {/* Success Icon with animation */}
          <div className="mb-6 relative">
            <div className="bg-gradient-to-r from-green-100 to-emerald-100 p-6 rounded-full shadow-sm ring-4 ring-green-50 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-customGreen/20 to-custom-bright-green/20 rounded-full animate-pulse"></div>
              <FiCheckCircle className="text-customGreen text-5xl mx-auto relative z-10" />
            </div>
            {/* Success ripple effect */}
            <div className="absolute inset-0 rounded-full border-2 border-green-200 animate-ping opacity-30"></div>
          </div>

          {/* Success Message */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold mb-2 bg-gradient-to-r from-customGreen to-custom-bright-green bg-clip-text text-transparent">
              Process Completed Successfully!
            </h2>
            <p className="text-gray-600 text-sm font-medium">
              Your property has been confirmed and is ready for presentation
            </p>
          </div>

          {/* Property Information Card */}
          {selectedPropertyData && (
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 mb-6 border border-gray-200/60 min-w-[300px]">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-500 font-medium">Property Type</span>
                <span className="px-3 py-1 bg-customGreen/10 text-customGreen rounded-full text-sm font-semibold">
                  {selectedPropertyData?.propertyType?.name}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500 font-medium">Sale Type</span>
                <span className="text-sm text-gray-700 font-semibold">
                  {selectedPropertyData?.propertySaleType?.name}
                </span>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={() => {
                if (presentationProperty && presentationProperty.id) {
                  handleExitingSubmite();
                } else {
                  handleSubmit();
                }
              }}
              disabled={isLoading}
              className="group relative px-8 py-3 bg-gradient-to-r from-customGreen to-custom-bright-green text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center gap-2"
            >
              {isLoading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  <span>Loading...</span>
                </>
              ) : (
                <>
                  <MdVisibility className="text-xl" />
                  <span>View Property</span>
                </>
              )}
              <div className="absolute inset-0 bg-white/20 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>

         
          </div>

      
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-center animate-fadeIn z-10 relative">
          {/* Warning Icon */}
          <div className="mb-6 relative">
            <div className="bg-gradient-to-r from-red-100 to-red-100 p-6 rounded-full shadow-sm ring-4 ring-red-50">
              <FiAlertTriangle className="text-red-500 text-5xl mx-auto" />
            </div>
          </div>

          {/* Warning Message */}
          <div className="mb-6">
            <h2 className="text-xl font-bold mb-2 text-red-600">
              Property Not Confirmed
            </h2>
            <p className="text-gray-600 text-sm">
              Please complete all required property details to proceed
            </p>
          </div>

          {/* Information Card */}
          {/* <div className="bg-yellow-50/80 backdrop-blur-sm rounded-xl p-6 border border-yellow-200/60 max-w-md">
            <div className="flex items-start gap-3">
              <MdWarning className="text-yellow-500 text-xl mt-0.5 flex-shrink-0" />
              <div className="text-sm text-gray-700">
                <p className="font-medium mb-1">Next Steps:</p>
                <ul className="list-disc list-inside space-y-1 text-gray-600">
                  <li>Complete all required property details</li>
                  <li>Verify property information</li>
                  <li>Confirm the property status</li>
                </ul>
              </div>
            </div>
          </div> */}

          {/* Property Info if available */}
          {selectedPropertyData && (
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 mb-6 border border-gray-200/60 min-w-[300px]">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-500 font-medium">Property Type</span>
                <span className="px-3 py-1 bg-customGreen/10 text-customGreen rounded-full text-sm font-semibold">
                  {selectedPropertyData?.propertyType?.name}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500 font-medium">Sale Type</span>
                <span className="text-sm text-gray-700 font-semibold">
                  {selectedPropertyData?.propertySaleType?.name}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InSalesPage;
